import { BaseAction } from '../commons'

export const REMOVE_PRACTICE_SUBMIT = 'REMOVE_PRACTICE/REMOVE_PRACTICE_SUBMIT'
export const REMOVE_PRACTICE_SUCCESS = 'REMOVE_PRACTICE/REMOVE_PRACTICE_SUCCESS'
export const REMOVE_PRACTICE_FAIL = 'REMOVE_PRACTICE/REMOVE_PRACTICE_FAIL'
export const REMOVE_PRACTICE_RESET = 'REMOVE_PRACTICE/REMOVE_PRACTICE_RESET'

export interface RemovePracticeAction extends BaseAction {
  type: typeof REMOVE_PRACTICE_SUBMIT
  payload: {
    providerNumber: string
    practiceName: string
  }
}

export interface RemovePracticeFailAction extends BaseAction {
  type: typeof REMOVE_PRACTICE_FAIL
  error: string
}

export interface RemovePracticeSuccessAction extends BaseAction {
  type: typeof REMOVE_PRACTICE_SUCCESS
  data: {
    providerNumber: string
    practiceName: string
  }
}

export const removePractice = (providerNumber: string, practiceName: string): RemovePracticeAction => ({
  type: REMOVE_PRACTICE_SUBMIT,
  payload: { providerNumber, practiceName },
})

export const removePracticeSuccess = (providerNumber: string, practiceName: string): RemovePracticeSuccessAction => ({
  type: REMOVE_PRACTICE_SUCCESS,
  data: { providerNumber, practiceName },
})

export const removePracticeFail = (error: string): RemovePracticeFailAction => ({
  type: REMOVE_PRACTICE_FAIL,
  error,
})

export const removePracticeReset = (): BaseAction => ({
  type: REMOVE_PRACTICE_RESET,
})
